var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e2) {
        reject(e2);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e2) {
        reject(e2);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { S as STATE_MANAGEMENT_API_HOST, d as decodeStorage, g as getExpirationDate, a as getCookieString, C as COOKIE_STORAGE, L as LOCAL_STORAGE, b as SESSION_STORAGE, w as webStorage, c as STATE_MANAGEMENT } from "./index-B3cqF6Mz.js";
import { E, e, f, i, j, u, h } from "./index-B3cqF6Mz.js";
const getState = (_0) => __async(void 0, [_0], function* ({ nuggetKey, nuggetNamespace, svocId, userId }) {
  let result;
  if (userId && svocId) {
    let url = `${STATE_MANAGEMENT_API_HOST}/nugget/${userId}/${svocId}`;
    if (nuggetNamespace) {
      url += `/${nuggetNamespace}`;
      if (nuggetKey) {
        url += `/${nuggetKey}`;
      }
    }
    try {
      result = yield fetch(url);
    } catch (error) {
      throw new Error(`Error received from state management API: ${error}`);
    }
  } else {
    throw new Error("State management API requires both userId and svocId");
  }
  return result;
});
const stateManagement = /* @__PURE__ */ Object.create({
  set: () => {
    throw new Error("Method set() not yet implemented");
  },
  get: getState,
  remove: () => {
    throw new Error("Method remove() not yet implemented");
  }
});
const setCookie = ({
  domain = ".homedepot.com",
  expiration = "year",
  key,
  path = "/",
  value
}) => {
  if (typeof document !== "undefined") {
    const expires = getExpirationDate(expiration);
    document.cookie = getCookieString({
      key,
      value,
      expires,
      path,
      domain
    });
  }
};
const getCookie = ({ key }) => {
  let cookie;
  const cookieList = document.cookie.split(";");
  cookie = key ? cookieList.find((row) => row.includes(key.trimStart())) : "";
  cookie = decodeStorage(cookie == null ? void 0 : cookie.split("=")[1]);
  return cookie;
};
const removeCookie = ({ key, domain }) => {
  setCookie({
    key,
    expiration: -1,
    domain
  });
};
const cookieStorage = /* @__PURE__ */ Object.create({
  set: setCookie,
  get: getCookie,
  remove: removeCookie
});
class THDStorage {
  constructor() {
    __publicField(this, "defaultSetOpts", {
      path: "/",
      domain: ".homedepot.com",
      nuggets: []
    });
  }
  /**
   * @public
   * @function set
   * @description Allows consumers to set cookie/localstorage/sessionstorage data.
   * @param {AccessType} accessType - Type of Storage Module (cookie, local, session)
   * @param {StorageOptions} options - [See the StorageOptions TypeDef](#storage-options)
   * @example
   * import THDStorageUtils, {COOKIE_STORAGE} from '@thd-olt-global/thd-storage-utils';
   * // ...
   * THDStorageUtils.set(COOKIE_STORAGE, { key: 'foo', value: 'bar' });
   */
  set(accessType, options = this.defaultSetOpts) {
    const opts = __spreadValues(__spreadValues({}, this.defaultSetOpts), options);
    const {
      appKey,
      key,
      value,
      expiration,
      path,
      domain,
      userId,
      svocId,
      nuggets
    } = opts;
    if (accessType === COOKIE_STORAGE) {
      cookieStorage.set({
        key,
        value,
        expiration,
        path,
        domain
      });
    }
    if (accessType === LOCAL_STORAGE || accessType === SESSION_STORAGE) {
      webStorage.set({
        accessType,
        key,
        value,
        expiration
      });
    }
    if (accessType === STATE_MANAGEMENT) {
      stateManagement.set({
        accessType,
        userId,
        svocId,
        nuggets,
        appKey
      });
    }
    if (typeof window !== "undefined" && window.LIFE_CYCLE_EVENT_BUS) {
      window.LIFE_CYCLE_EVENT_BUS.trigger(`dataStorage.${accessType}`, {
        key,
        appKey
        // Need to figureout how to get app key
      });
    }
  }
  /**
   * @public
   * @function get
   * @description Allows consumers to Get cookie/localstorage/sessionstorage data.
   * @param {AccessType} accessType - Type of Storage Module (cookie, local, session)
   * @param {StorageOptions} options - [See the StorageOptions TypeDef](#storage-options)
   *
   * @example
   * import THDStorageUtils, {SESSION_STORAGE} from '@thd-olt-global/thd-storage-utils';
   * // ...
   * const storageValue =
   *  THDStorageUtils.get(SESSION_STORAGE, { key: 'MY_AWESOME_SESSION_STORAGE_KEY' };
   */
  get(accessType, options = {}) {
    let data;
    const { key, returnString = true } = options;
    switch (accessType) {
      case COOKIE_STORAGE: {
        data = cookieStorage.get({ key });
        break;
      }
      case LOCAL_STORAGE:
      case SESSION_STORAGE: {
        data = webStorage.get({ accessType, key, returnString });
        break;
      }
      default: {
        const errorMessage = `first argument must be one of 
        ${COOKIE_STORAGE},
        ${LOCAL_STORAGE},
        or ${SESSION_STORAGE}`;
        throw new Error(errorMessage);
      }
    }
    return data;
  }
  /**
   * @public
   * @function getState
   * @description A method to get data from the state management api.
   * This method needs to be async since it interacts with a REST service
   * so a method separate from the generic `get` method was provided.
   * @param {StorageOptions} options - Holds { userId, svocId, nuggetNamespace, nuggetKey }
   *
   * @example
   * import THDStorageUtils from '@thd-olt-global/thd-storage-utils';
   * // ...
   * const value = await THDStorageUtils.getState({
   *  userId: 'foo', svocId: 'bar', nuggetNamespace: 'fez', nuggetKey: 'bear'
   * });
   */
  getState() {
    return __async(this, arguments, function* (options = {}) {
      const { nuggetKey, nuggetNamespace, svocId, userId } = options;
      return stateManagement.get({
        nuggetKey,
        nuggetNamespace,
        svocId,
        userId
      });
    });
  }
  /**
   * @public
   * @function remove
   * @description Allows consumers to delete cookie/localstorage/sessionstorage data.
   * @param {AccessType} accessType - Type of Storage Module (cookie, local, session)
   * @param {StorageOptions} options -
   * Holds { key, domain, userId, svocId, nuggetNamespace, nuggetKey }
   *
   *
   * @example
   * import THDStorageUtils, {LOCAL_STORAGE} from '@thd-olt-global/thd-storage-utils';
   * // ...
   * THDStorageUtils.remove(LOCAL_STORAGE, {key: 'SUPER_DUPER_LOCAL_STORAGE_KEY'});
   */
  remove(accessType, options = {}) {
    const {
      key,
      domain,
      userId,
      svocId,
      nuggetNamespace,
      nuggetKey
    } = options;
    if (accessType === COOKIE_STORAGE) {
      cookieStorage.remove({ key, domain });
    }
    if (accessType === LOCAL_STORAGE || accessType === SESSION_STORAGE) {
      webStorage.remove({ accessType, key });
    }
    if (accessType === STATE_MANAGEMENT) {
      stateManagement.remove({
        userId,
        svocId,
        nuggetNamespace,
        nuggetKey
      });
    }
  }
}
const instance = new THDStorage();
export {
  COOKIE_STORAGE,
  E as EXPIRE_DAY,
  e as EXPIRE_MONTH,
  f as EXPIRE_YEAR,
  LOCAL_STORAGE,
  SESSION_STORAGE,
  STATE_MANAGEMENT,
  instance as default,
  i as initIndexDB,
  j as useIndexedDB,
  u as useLocalStorage,
  h as useSessionStorage
};
